var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 73,
    viewBox: "0 0 104 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GO_logo_svg__GO_logo_svg__Canvas",
    transform: "translate(6892 8533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GO_logo_svg__GO_logo_svg__Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GO_logo_svg__GO_logo_svg__Ellipse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#GO_logo_svg__GO_logo_svg__path0_fill",
    transform: "translate(-6840.84 -8532.38)",
    fill: "#FBFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "GO_logo_svg__GO_logo_svg__Ellipse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#GO_logo_svg__GO_logo_svg__path1_fill",
    transform: "translate(-6826.84 -8518.38)",
    fill: "#EE5044"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "GO_logo_svg__GO_logo_svg__mask0_outline_ins"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#GO_logo_svg__GO_logo_svg__path1_fill",
    fill: "white",
    transform: "translate(-6826.84 -8518.38)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#GO_logo_svg__GO_logo_svg__mask0_outline_ins)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#GO_logo_svg__GO_logo_svg__path2_stroke_2x",
    transform: "translate(-6826.84 -8518.38)",
    fill: "#31384A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "GO_logo_svg__GO_logo_svg__G"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#GO_logo_svg__GO_logo_svg__path3_fill",
    transform: "translate(-6892 -8533)",
    fill: "#FBFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "GO_logo_svg__GO_logo_svg__Polygon"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#GO_logo_svg__GO_logo_svg__path4_fill",
    transform: "matrix(-1 -1.22465e-16 1.22465e-16 -1 -6795.34 -8460.38)",
    fill: "#EE5044"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "GO_logo_svg__GO_logo_svg__path0_fill",
    d: "M 52 26C 52 40.3594 40.3594 52 26 52C 11.6406 52 0 40.3594 0 26C 0 11.6406 11.6406 0 26 0C 40.3594 0 52 11.6406 52 26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "GO_logo_svg__GO_logo_svg__path1_fill",
    d: "M 24 12C 24 18.6274 18.6274 24 12 24C 5.37258 24 0 18.6274 0 12C 0 5.37258 5.37258 0 12 0C 18.6274 0 24 5.37258 24 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "GO_logo_svg__GO_logo_svg__path2_stroke_2x",
    d: "M 22 12C 22 17.5228 17.5228 22 12 22L 12 26C 19.732 26 26 19.732 26 12L 22 12ZM 12 22C 6.47715 22 2 17.5228 2 12L -2 12C -2 19.732 4.26801 26 12 26L 12 22ZM 2 12C 2 6.47715 6.47715 2 12 2L 12 -2C 4.26801 -2 -2 4.26801 -2 12L 2 12ZM 12 2C 17.5228 2 22 6.47715 22 12L 26 12C 26 4.26801 19.732 -2 12 -2L 12 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "GO_logo_svg__GO_logo_svg__path3_fill",
    d: "M 47.002 48.564C 44.5407 49.842 41.6533 50.8833 38.34 51.688C 35.074 52.4927 31.5003 52.895 27.619 52.895C 23.5957 52.895 19.88 52.256 16.472 50.978C 13.1113 49.7 10.2003 47.9013 7.739 45.582C 5.325 43.2627 3.43167 40.4937 2.059 37.275C 0.686334 34.009 0 30.388 0 26.412C 0 22.3887 0.686334 18.744 2.059 15.478C 3.479 12.212 5.41967 9.443 7.881 7.171C 10.3423 4.85167 13.2297 3.07667 16.543 1.846C 19.8563 0.615334 23.43 0 27.264 0C 31.24 0 34.932 0.615334 38.34 1.846C 41.748 3.02933 44.517 4.63867 46.647 6.674L 38.979 15.407C 37.7957 14.0343 36.2337 12.922 34.293 12.07C 32.3523 11.1707 30.1513 10.721 27.69 10.721C 25.56 10.721 23.5957 11.1233 21.797 11.928C 19.9983 12.6853 18.4363 13.774 17.111 15.194C 15.7857 16.5667 14.7443 18.2233 13.987 20.164C 13.277 22.0573 12.922 24.14 12.922 26.412C 12.922 28.7313 13.2533 30.8613 13.916 32.802C 14.5787 34.7427 15.549 36.423 16.827 37.843C 18.1523 39.2157 19.7617 40.3043 21.655 41.109C 23.5957 41.8663 25.7967 42.245 28.258 42.245C 29.678 42.245 31.027 42.1503 32.305 41.961C 33.583 41.7243 34.7663 41.3693 35.855 40.896L 35.855 31.737L 26.27 31.737L 26.27 21.939L 47.002 21.939L 47.002 48.564Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "GO_logo_svg__GO_logo_svg__path4_fill",
    d: "M 20.5 0C 25.5 0 40 22.5 40 22.5C 23.1602 14.6172 16.6602 14.1172 0 22.5C 0 22.5 16 0.000223111 20.5 0Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoLogo);
export default __webpack_public_path__ + "static/media/GO_logo.1ccf07fcb435f86ed9c2946c9b6f87e7.svg";
export { ForwardRef as ReactComponent };